// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/next.scss
// module id = 879
// module chunks = 142